var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"panel panel-default tw-mb-0"},[_c('div',{staticClass:"panel-body"},[_c('h3',{staticClass:"tw-mt-2 tw-mb-4"},[_vm._v("\n      "+_vm._s(_vm.publication.attributes.theme)+"\n    ")]),_vm._v(" "),_c('p',{staticClass:"tw-whitespace-pre-line tw-mb-0"},[_vm._v(_vm._s(_vm.publication.attributes.theme_description))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }